import useQueryUserData from "@widget/authorization/hooks/useQueryUserData";
import api from "@widget/contexts/api";
import type { PodcastApiResponse } from "@widget/contexts/podcast/types";
import type { ApiResponse } from "@widget/contexts/types";
import { useQuery } from "@tanstack/react-query";

export const QUERY_LIKED_PODCASTS_LIST_KEY = "liked-podcasts-list";

type Response = ApiResponse<unknown, PodcastApiResponse["data"]>;

async function query(userId: number) {
  const { data } = await api.get<Response>(`/user/${userId}/loved-podcasts`);

  return data;
}

export function useQueryUserLikedPodcastsList() {
  const { data: userData } = useQueryUserData();

  return useQuery({
    queryKey: [QUERY_LIKED_PODCASTS_LIST_KEY],
    queryFn: () => query(userData?.user?.USER?.USER_ID as number),
    enabled:
      Boolean(userData?.isLogged) && Boolean(userData?.user?.USER?.USER_ID),
  });
}
